export default function daysInFeb(year: number) {
  if (year % 4 === 0 && year % 100 !== 0) {
    return 29;
  }
  if (year % 400 === 0) {
    return 29;
  }
  return 28;
}
